import { IBaseAutocomplete } from "@/types";
import { ITag } from "@/api/types/user";
import { IServerResponse } from "@/api/types";
import { ComputedRef, InjectionKey, Ref } from "vue";

export interface IAffiliateEditContext {
    editableFields: Ref<Record<EDITABLE_FIELD, any>>;
    editItem: (key: EDITABLE_FIELD, value: any) => void;
    isFieldValid: (rule: (v: string) => boolean, key: EDITABLE_FIELD) => ComputedRef<boolean>;
    isMessengerValid: ComputedRef<boolean>;
    getChangedValues: ComputedRef<Record<string, any>>;
    resetFields: (keys: EDITABLE_FIELD[]) => void;
}

export const AFFILIATE_EDIT_KEY: InjectionKey<IAffiliateEditContext> = Symbol('affiliateEdit');

export enum EDITABLE_FIELD {
    NEWCOMER = 'newcomer',
    MASTER_ID = 'master_id',
    MASTER_EXTENSION = 'master_extension',
    INVOICE_MASTER = 'invoice_master',
    LAST_NAME = 'last_name',
    FIRST_NAME = 'first_name',
    NICKNAME = 'nickname',
    STATUS = 'status',
    MANAGER = 'manager',
    MESSENGER = 'messenger',
    PHONE = 'phone',
    BIRTHDAY = 'birthday',
    COUNTRY = 'country',
    CITY = 'city',
    LANGUAGE = 'language',
    THEME = 'theme',
    OPEN_ERID = 'open_erid',
    ADVANCE_PAYMENTS = 'advance_payments',
    VERTICALS = 'verticals',
    TRAFFIC_SOURCES = 'traffic_sources',
    TAGS = 'tags',
    CONTRACT_TYPE = 'contract_type',
    EMAIL = 'email',
    TIMEZONE = 'timezone',
    BALANCE = 'balance',
    HOLD_DAYS = 'hold_days',
    HOLD_PAYMENTS = 'hold_payments',
}

export enum AFFILIATE_INFO_TYPE {
    TEXT = "text",
    DATE = "date",
    CHIP = "chip",
    CHIP_ARRAY = "chip-array",
    SWITCH = "switch",
    STATUS = 'status',
    MESSENGER = "messenger",
    EMAIL = "email",
    VERIFIED = "verified",
    CONTRACT_TYPE = 'contract_type',
}

export enum AFFILIATE_INFO_EDIT_TYPE {
    TEXT = "text",
    SELECT = "select",
    AUTOCOMPLETE = "autocomplete",
    MESSENGER = "messenger",
    PHONE = "phone",
    EMAIL = "email",
    DATE = "date",
    TAG_SELECT = "tag",
    NUMBER = "number",
}

export interface IAffiliateInfoItem {
    type: AFFILIATE_INFO_TYPE;
    name: string;
    value: any;
    defaultValue?: any;
    textValue?: string | string[];
    trueValue?: string | number;
    falseValue?: string | number;
    icon?: SVGElement;
    editType?: AFFILIATE_INFO_EDIT_TYPE;
    link?: string;
    tooltipText?: string;
    class?: string;
    isMaster?: boolean;
    isEditable?: boolean;
    isDisabled?: boolean;
    /** Текст подсказки, почему поле недоступно для редактирования */
    disabledHint?: string;
    isVerified?: boolean;
    isDisabledBtn?: boolean;
    isValid?: boolean;
    hint?: string;
    autocompleteData?: IBaseAutocomplete;
    translateMethod?: (value: string) => any;
    selectItems?: any[];
    max?: number;
    selectData?: {
        itemValue?: string;
        itemText?: string;
        isMultiple?: boolean;
        isAutocomplete?: boolean;
        isClearable?: boolean;
        clearValue?: number;
        filter?: (item: any, queryText: string, itemText: string) => boolean;
    };
    tagSelectData?: {
        getTagsMethod: () => Promise<ITag[]>;
        createTagMethod: (data: { name: string }) => Promise<IServerResponse<any>>;
    };
    editMethod?: (...args: any) => void;
    updateMethod?: (...args: any) => Promise<void>;
    checkEmail?: (...args: any) => Promise<void>;
}

export interface ISimpleCard {
    title: string;
    items: Record<string, IAffiliateInfoItem>;
}
